
const baseUrl = process.env.REACT_APP_BASE_URL;

class StockService {


    addProduct = (productId, quantity)  =>{



        const token = localStorage.getItem('token');

        const requestData = {
            "productId": productId,
            "quantity": quantity,
            "type": "ADD"
        }

        return fetch(baseUrl + '/stock/add/product', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }


    productList = (name, model, brand, size, supplierUniqueId)  =>{



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
            "supplierUniqueId": supplierUniqueId
        }

        return fetch(baseUrl + '/stock/product/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    transactionList = (name, model, brand, size, type)  =>{



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
            "type": type,
        }

        return fetch(baseUrl + '/stock/product/transactions', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

}

export default StockService;